
import { FileDocumentStatus, FileDocumentStatusHistory, Time } from '@/model';
import users from '@/store/users';
import { groupBy } from '@/util/array-util';
import Vue from 'vue';

export default Vue.extend({
  name: 'StatusHistoryTimeline',
  props: {
    statues: { type: Array as () => FileDocumentStatusHistory[], required: true },
  },
  data() {
    return {
      from: undefined as Time | undefined,
      to: undefined as Time | undefined,
    };
  },
  computed: {
    sorted(): FileDocumentStatusHistory[] {
      return [...this.statues].sort((a, b) => a.time - b.time);
    },
    byDocument(): ReadonlyMap<number, readonly FileDocumentStatusHistory[]> {
      return groupBy(this.sorted, (e) => e.documentId);
    },
  },
  methods: {
    user(userId: number | undefined) {
      return userId ? users.getters.lookup.get(userId)?.displayName : '';
    },
    time(time: Time) {
      return Time.asString(time);
    },
    statusName(status: FileDocumentStatus) {
      return FileDocumentStatus.name(status);
    },
  },

});
